<script lang="ts">
	import PreferenceToggle from './PreferenceToggle.svelte';
	import { appearance, resolvedAppearance, setAppearance } from '$lib/appearance';
</script>

<PreferenceToggle
	label="Toggle theme"
	icon={$resolvedAppearance === 'dark' ? 'fa-moon' : 'fa-sun'}
	iconLabel={$resolvedAppearance === 'dark' ? 'Dark appearance' : 'Light appearance'}
	value={$appearance}
	options={[
		{ value: 'system', label: 'System' },
		{ value: 'light', label: 'Light' },
		{ value: 'dark', label: 'Dark' }
	]}
	onChange={setAppearance}
/>
